module.exports = __webpack_public_path__ + "fonts/ee65399.ttf";